import { useEffect, useState } from "react"
import { Route, Routes } from "react-router-dom"
import { Header } from "./components/Header"
import { CartDrawer } from "./components/CartDrawer"
import { Catalog } from "./pages/Catalog"
import { CheckoutSuccess } from "./pages/CheckoutSuccess"
import { CheckoutCancel } from "./pages/CheckoutCancel"
import { Wrap } from "./components/ui"
import { CONFIG } from "./config"
import { displayName, initAuth, login, logout } from "./auth"
import { useCart } from "./cart"

export default function App() {
  const { count } = useCart()
  const [authed, setAuthed] = useState(false)
  const [cartOpen, setCartOpen] = useState(false)

  useEffect(() => {
    initAuth()
      .then(setAuthed)
      .catch(() => setAuthed(false))
  }, [])

  return (
    <div className="flex min-h-full flex-col">
      <Header
        authed={authed}
        name={authed ? displayName() : ""}
        cartCount={count}
        onOpenCart={() => setCartOpen(true)}
        onLogin={login}
        onLogout={logout}
      />

      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Catalog />} />
          <Route path="/checkout/success" element={<CheckoutSuccess authed={authed} />} />
          <Route path="/checkout/cancel" element={<CheckoutCancel />} />
          <Route
            path="*"
            element={<Wrap className="py-24 text-center text-brand-muted">Seite nicht gefunden.</Wrap>}
          />
        </Routes>
      </main>

      <footer className="border-t border-line py-8">
        <Wrap className="flex flex-col items-start justify-between gap-3 text-xs text-brand-muted md:flex-row md:items-center md:text-sm">
          <div className="flex items-center gap-3">
            <a href={CONFIG.agbUrl} className="hover:underline">AGB</a>
            <span aria-hidden>·</span>
            <a href={CONFIG.datenschutzUrl} className="hover:underline">Datenschutz</a>
            <span aria-hidden>·</span>
            <a href={CONFIG.impressumUrl} className="hover:underline">Impressum</a>
          </div>
          <div>© {new Date().getFullYear()} SINUS Markt- und Sozialforschung GmbH</div>
        </Wrap>
      </footer>

      <CartDrawer
        open={cartOpen}
        authed={authed}
        onClose={() => setCartOpen(false)}
        onLogin={login}
      />
    </div>
  )
}
